// extracted by mini-css-extract-plugin
export default {"timerRoot":"Timer_timerRoot__mFXx8","buttonImg":"Timer_buttonImg__koEkf"};